import { render, staticRenderFns } from "./RevisionDocumentosPCliente.vue?vue&type=template&id=10849854&scoped=true"
import script from "./RevisionDocumentosPCliente.vue?vue&type=script&lang=js"
export * from "./RevisionDocumentosPCliente.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./RevisionDocumentosPCliente.vue?vue&type=style&index=1&id=10849854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10849854",
  null
  
)

export default component.exports